<template>
  <vue-fragment v-if="isFilterVisible">
    <td v-for="filter in fields"
        v-show="show"
        :key="filter.key">
      <div v-if="!notIncludeKey.includes(filter.key)">
        <div v-if="!filter.trafficLights">
          <b-input v-model="filters[filter.key]"
                   :placeholder="filter.label">
          </b-input>
        </div>
        <div v-else>
          <b-form-select v-model="filters[filter.key]"
                         :options="prepareOptions(filter.trafficLightsOptionsType)">
            <template #first>
              <b-form-select-option value="">All</b-form-select-option>
            </template>
          </b-form-select>
        </div>
      </div>
    </td>
  </vue-fragment>
</template>
<script>
  import trafficLightsOptionsAcceptanceMarkFull from '@/json/trafficLightsAcceptanceMark';
  import trafficLightsOptionsSafety from '@/json/trafficLightsAcceptanceMarkSafety';

  export default {
    name: 'ProposalFilter',
    props: {
      fields: {
        type: Array,
        default: () => [],
      },
      value: {
        type: Array,
        default: () => [],
      },
      selectedCall: {
        type: String,
        default: 'None',
      },
      id: {
        type: Number,
        default: 1,
      },
      notIncludeKey: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        filters: {},
        filtersCached: {},
        proposalsFilter: {},
        proposals: [],
        // change to prop to setup this value from parent
        show: true,
      };
    },
    computed: {
      isFilterVisible() {
        return this.fields.length !== 0
          && (Object.keys(this.filtersCached).includes(this.selectedCall) || this.selectedCall === 'None');
      },
      trafficLightsOptionsAcceptanceMarkFull() {
        return trafficLightsOptionsAcceptanceMarkFull.map((option) => ({
          ...option,
          text: option.text.charAt(0).toUpperCase() + option.text.slice(1),
        }));
      },
      trafficLightsOptionsAcceptanceMarkLimited() {
        return [
          this.trafficLightsOptionsAcceptanceMarkFull[0],
          this.trafficLightsOptionsAcceptanceMarkFull[this.trafficLightsOptionsAcceptanceMarkFull.length - 1],
        ];
      },
      trafficLightsOptionsSafety() {
        return trafficLightsOptionsSafety;
      },
    },
    methods: {
      createFilter(key) {
        const filter = {};
        key.forEach((item) => {
          filter[item.key] = '';
        });
        return filter;
      },
      getFiltered(items, fields) {
        const exactMatchKeys = [
          'samples[0].safety_evaluation.status',
          'samples[0].radiation_evaluation.status',
          'additional_sample_declaration.safety_evaluation.status',
          'additional_sample_declaration.radiation_evaluation.status',
        ];

        return items.filter((item) => Object.keys(fields).every((key) => {
          const itemValue = this.lower(String(this.getItem(item, key)));
          const filterValue = this.lower(fields[key]);
          if (exactMatchKeys.includes(key) && filterValue !== '') {
            return itemValue === filterValue;
          }
          return itemValue.includes(filterValue);
        }));
      },
      getItem(item, key) {
        // check the deeper key level (e.g. value for key "general.discipline")

        // if the deeper key includes an Array (e.g key "samples[0].risk");
        if (key.includes('[0].')) {
          return key.split('.').reduce((o, k) => {
            if (o !== undefined) {
              if (k.includes('[0]')) {
                const cleanKey = k.slice(0, -3);
                if (this.hasProperty(o, cleanKey)) return o[cleanKey][0];
              }
              if (this.hasProperty(o, k)) {
                // if final value is an Array (e.g. samples[0].sample_safety)
                if (Array.isArray(o[k])) {
                  return o[k].join(', ');
                }
                return o[k];
              }
            }
            return undefined;
          }, item);
        }

        if (key.includes('.')) {
          return key.split('.').reduce((o, k) => {
            if (o !== undefined) {
              if (this.hasProperty(o, k)) return o[k];
            }
            return undefined;
          }, item);
        }
        return item[key];
      },
      lower(str) {
        return typeof str === 'string' || str instanceof String
          ? str.toLowerCase() : str;
      },
      setup(proposal) {
        // this is use as main collection to do filter logic
        this.proposals = proposal;
      },
      setupUserFilters(proposal) {
        // setup for users filtered by creation date and / or is_active
        this.proposals = proposal;
        const proposals = this.getFiltered(this.proposals, this.filters);
        this.updateProposals(proposals);
      },
      // update filter is use for all filter component on the b-tabs
      // TO-DO: create logic and update only one component that is visible
      updateProposals(proposals, allowId) {
        if (this.id === allowId || allowId === undefined) {
          if (proposals !== undefined) {
            this.$set(this, 'proposalsFilter', proposals);
          } else {
            const localProposals = this.getFiltered(this.proposals, this.filters);
            this.updateProposals(localProposals);
          }
        }
      },
      parseFilters() {
        if (!Object.keys(this.filtersCached).includes(this.selectedCall)) {
          this.filtersCached[this.selectedCall] = this.createFilter(this.fields);
        }
        this.filters = this.filtersCached[this.selectedCall];
      },
      prepareOptions(optionsType) {
        return this[optionsType];
      },
    },
    watch: {
      selectedCall: {
        handler() {
          this.parseFilters();
        },
        immediate: true,
      },
      proposalsFilter() {
        this.$emit('input', this.proposalsFilter);
      },
      filters: {
        handler() {
          const proposals = this.getFiltered(this.proposals, this.filters);
          this.updateProposals(proposals);
        },
        deep: true,
      },
    },
    created() {
      const parent = this.getParentById(this.id);
      parent.$on('setup-proposal', this.setup);
      parent.$on('setup-proposal-user-filters', this.setupUserFilters);
      // event to toggle visible of the filters input's
      parent.$on('toggle-show', () => {
        this.$set(this, 'show', !this.show);
      });
      parent.$on('refresh', this.updateProposals);
      this.$emit('component-created');
    },
  };
</script>
